const breadCrumb = "Lotação de Servidores - Carga Horária";

const routes = [
  {
    path: "/montar-carga-horaria",
    name: "montar-carga-horaria",
    meta: {
      allowedPermissions: ["carga_horaria_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/MontarCargaHoraria/MontarCargaHorariaHome.vue"
      ),
  },
  {
    path: "/montar-carga-horaria/novo",
    name: "montar-carga-horaria-novo",
    meta: {
      allowedPermissions: ["carga_horaria_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/MontarCargaHoraria/MontarCargaHorariaCad.vue"
      ),
  },
  {
    path: "/montar-carga-horaria/editar/:id",
    name: "montar-carga-horaria-editar",
    meta: {
      allowedPermissions: ["carga_horaria_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/MontarCargaHoraria/MontarCargaHorariaEdit.vue"
      ),
  },
];

export default routes;
